function BrokenComponent() {
    throw new Error("Test error: This crash was intentional to test the GlobalErrorBoundary");
}

export default function TestErrorBoundary() {
    return <BrokenComponent />;
}
